import type { AdminOrderTermination } from '@inflip/contracts/admin';
import {
  RefundStatus,
  TERMINATION_REFUND_MODE_LABELS,
  TerminationRefundMode,
} from '@inflip/shared';

import { Badge } from './ui';

/**
 * 상태 "계약 해지" 옆에 항상 같이 붙는 선불 처리 배지 — 비환불 / 부분 환불(선불) N원 / 전액 환불(선불).
 * 해지와 함께 만든 환불이 송금 전이면 '환불 진행 중'을 덧붙인다.
 */
export function TerminationBadge({
  termination,
}: {
  termination: Pick<AdminOrderTermination, 'refundMode' | 'refundAmount' | 'refundStatus'>;
}) {
  const label =
    termination.refundMode === TerminationRefundMode.PARTIAL
      ? `${TERMINATION_REFUND_MODE_LABELS.PARTIAL} ${termination.refundAmount.toLocaleString('ko-KR')}원`
      : TERMINATION_REFUND_MODE_LABELS[termination.refundMode];
  const inProgress =
    termination.refundStatus === RefundStatus.REQUESTED ||
    termination.refundStatus === RefundStatus.APPROVED;
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <Badge tone={termination.refundMode === TerminationRefundMode.NONE ? 'default' : 'red'}>
        {label}
      </Badge>
      {inProgress && <Badge tone="amber">환불 진행 중</Badge>}
    </span>
  );
}
